import { EconomicsScenarioDetails, Id } from "PFTypes";

import api from "../../api";

export type FetchActivityEconomicsScenarioResponse = EconomicsScenarioDetails;

export const fetchActivityEconomicsScenario = async (scenarioId: Id) =>
  api<FetchActivityEconomicsScenarioResponse>({ url: `scenarios/${scenarioId}` });
